import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";
import { API_URL } from "../services/api";
import { useCookies } from "react-cookie";
import Toast from "../util/toast/Toast";
import axios from "axios";

// import "./login.scss";

const Login = ({ showloading, setShowLoading }) => {
    const [cookies, setCookie] = useCookies(["user", "token"]);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();

    let toastProperties = null;
    const [messagesList, setMessages] = useState([]);

    useEffect(() => {
        setShowLoading(false);
    }, []);

    const showToast = (title, message, type) => {
        const id = Math.floor(Math.random() * 101 + 1);
        toastProperties = {
            id,
            title: title,
            description: message,
            type: type,
        };
        setMessages([...messagesList, toastProperties]);
    };

    const onSubmit = (data, e) => {
        axios
            .post(API_URL + "login", data)
            .then((res) => {
                setCookie("user", res.data, { path: "/" });
                setCookie("token", res.data.access_token, { path: "/" });
            })
            .catch((error) => {
                showToast("Error", "Unauthorized", "danger");
            });
    };

    return (
        <div className="container">
            <Toast
                toastList={messagesList}
                position={"bottom-right"}
                autoDelete={true}
                dismissTime={3000}
            />
            <div className="row" id="login-user">
                <div className="border rounded-3 col-6">
                    <form className="" onSubmit={handleSubmit(onSubmit)}>
                        <div className="col-md-8 offset-md-2 mt-5 mb-5">
                            <div>
                                <h1 className="text-center mb-3">Log in</h1>
                            </div>
                            <div className="form-floating mb-3">
                                <input
                                    type="email"
                                    className={`input-border form-control  ${
                                        errors.email ? "is-invalid" : ""
                                    }`}
                                    {...register("email", {
                                        required: "Obligatory field",
                                    })}
                                    name="email"
                                    id="floatingInput"
                                    placeholder="name@example.com"
                                />
                                <label>Email address</label>
                                {errors.email && (
                                    <div className="invalid-feedback">
                                        {errors.email.message}
                                    </div>
                                )}
                            </div>

                            <div className="form-floating  mb-3">
                                <input
                                    type="password"
                                    className={`input-border form-control  ${
                                        errors.password ? "is-invalid" : ""
                                    }`}
                                    {...register("password", {
                                        required: "Obligatory field",
                                    })}
                                    name="password"
                                    id="floatingPassword"
                                    placeholder="Password"
                                />
                                <label>Password</label>
                                {errors.password && (
                                    <div className="invalid-feedback">
                                        {errors.password.message}
                                    </div>
                                )}
                            </div>

                            <div className="d-grid ">
                                <button
                                    type="submit"
                                    className="btn-register btn btn-primary"
                                >
                                    Log in
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default Login;
